// extracted by mini-css-extract-plugin
export default {"overall-rating":"overall-rating--mp-lbDVC","overallRating":"overall-rating--mp-lbDVC"};